<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
<!--                        {{ $tc('message.obstetricParameters', 1) }}-->
                        {{$t('message.parameter') }}

                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="list-group list-group-flush">
                        <b-container>
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.weight') }}:

                                        <span class="font-weight-bold">
                                {{ mObstetricParameter.poids }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.taSystolique') }}:

                                        <span class="font-weight-bold">
                                {{ mObstetricParameter.ta_systolique}}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.taDiastolique') }}:

                                        <span class="font-weight-bold">
                                {{ mObstetricParameter.ta_diastolique }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.urineHeight') }}:

                                        <span class="font-weight-bold">
                                {{ mObstetricParameter.hauteur_urine }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.touchVaginal') }}:

                                        <span class="font-weight-bold">
                                {{ mObstetricParameter.toucher_vaginal }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.heartNoise') }}:

                                        <span class="font-weight-bold">
                                {{ mObstetricParameter.bruit_du_coeur }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <div class="card-footer text-right" v-if="mObstetricParameter.isAuthor || hasAdminRole">
                                <b-button variant="primary" @click="updateObstetricParameter">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.obstetricParameters', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mObstetricParameter.poids }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteObstetricParameter">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Obstetric",

        computed: {
            ...mapGetters(["obstetricParameter", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return  this.hasPraticienRole;
                }
            },

            mObstetricParameter: function() {
                return this.obstetricParameter;
            }
        },

        data() {
            return {
                obstetricParameter_id: this.$route.params.parametreObstetrique
            }
        },

        methods: {
            getObstetricParameter() {
                let args = {
                    parametreObstetrique: this.obstetricParameter_id
                };

                this.$store.dispatch("getObstetricParameter", { args });
            },

            formattedDate(date) {
                return date ? moment(date).format('DD-MM-YYYY HH:mm') : 'not yet';
            },

            updateObstetricParameter() {
                this.$router.push({ name: 'edit-parameter-obstetric', params: {consultation: this.obstetricParameter.consultation_prenatale.slug, parametreObstetrique: this.obstetricParameter_id } });
            },

            deleteObstetricParameter() {
                let self = this;
                let args = {
                    parametreObstetrique: this.obstetricParameter_id
                };

                let successMessage = this.$i18n.t('message.obstetricParameterDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteObstetricParameter', { args, index: self.obstetricParameter_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getObstetricParameter();
        }
    }
</script>

<style scoped>

</style>